import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageRegionProvider } from '@rx-applications/clientsite/shared/internationalization/data-access';
import { LANGUAGE_REGION_TOKEN } from '@rx-applications/clientsite/shared/internationalization/utils';
import { ThirdPartyLibraryModule } from '@rx-applications/shared/utils';
import { googleMapsLoaderFactory } from './factories';

@NgModule({
  imports: [CommonModule, ThirdPartyLibraryModule],
  providers: [
    LanguageRegionProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: googleMapsLoaderFactory,
      deps: [LANGUAGE_REGION_TOKEN],
      multi: true,
    },
  ],
})
export class GoogleMapsModule {
  constructor(
    @Optional() // because this dependency is not required
    @SkipSelf() // because we’re asking for a GoogleMapsModule dependency inside GoogleMapsModule!
    parentModule: GoogleMapsModule,
  ) {
    if (parentModule) {
      throw new Error('GoogleMapsModule has already been loaded. Import GoogleMapsModule in one place only.');
    }
  }
}
